// extracted by mini-css-extract-plugin
module.exports = {"overlay":"PageLoader_overlay__buKm_","loader":"PageLoader_loader__eg36L","bounce-in":"PageLoader_bounce-in__u0WjA","bounce":"PageLoader_bounce__ddHbf"};